import GlobalVariable from '@/global/global-variable'

// 查询 首页数据
const homeIndexApi = GlobalVariable.BASE_PATH + "/rest/home/index";

export default {
    // 查询 首页数据
    homeIndexApi,
    
}



// WEBPACK FOOTER //
// ./src/request/api-home.js